export default import.meta.ROLLDOWN_FILE_URL_tzk8H3Mj3bVVXr7Rsdc3Eg